<script setup lang="ts">
import { ref } from 'vue'

import type { StepAmountProps } from '~/components/simulator/StepAmount/interface'
import { useSimulatorData } from '~/composables/useSimulatorData'
import { formatNumberToLocale } from '~/composables/useFormatNumberToLocale'

defineProps<StepAmountProps>()

const { data, amountProps } = useSimulatorData()

const container = ref<HTMLElement | null>(null)

defineExpose({
  container,
})
</script>

<template>
  <section
    ref="container"
    class="SimulatorStepAmount radius-m border-normal border-blue-01"
    tabindex="-1"
  >
    <molecules-ui-fieldset :legend="$t('simulator.amountStep.title')">
      <div class="SimulatorStepAmount__content">
        <atoms-ui-currency
          id="amount"
          v-model="data.amount"
          symbol="€"
          placeholder="10 000"
        />
        <p class="paragraph-3 mt-1 color-blue-01">
          {{
            $t('simulator.amountStep.helpText', {
              min: formatNumberToLocale(amountProps.min),
              max: formatNumberToLocale(amountProps.max),
            })
          }}
        </p>
        <p
          v-if="errors?.amount"
          class="mt-2 label color-red-01"
        >
          {{ errors['amount'] }}
        </p>
      </div>
    </molecules-ui-fieldset>
  </section>
</template>

<style lang="scss" scoped>
.SimulatorStepAmount {
  overflow: hidden;
}

.SimulatorStepAmount__content {
  text-align: center;
}
</style>
